import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from "reactstrap";
import {
  DataTableHead,
  DataTableRow,
  DataTableItem,
  PaginationComponent,
  DataTable,
  Icon,
  DataTableBody,
} from "../../../Component";
import MyLoader from "../../../../MyComp/UI/form/MyLoader";

const ReviewTable = ({
  data,
  isLoading,
  paginate,
  currentPage,
  itemPerPage,
  limit,
  setonSearch,
  onSearch,
  setSearchText,
  onSearchText,
  setItemPerPage,
  noPagination,
  title,
}) => {
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    return isNaN(date.getTime()) ? value : date.toLocaleString();
  };

  return (
    <>
      <DataTable className={"card-stretch"}>
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <h5 className="title">{title}</h5>
            </div>
            <div className="card-tools me-n1">
              <ul className="btn-toolbar gx-1">
                <li>
                  <Button
                    color="link"
                    href="#search"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setonSearch(true);
                    }}
                    className="btn-icon search-toggle toggle-search"
                  >
                    <Icon name="search"></Icon>
                  </Button>
                </li>
                <li className="btn-toolbar-sep"></li>
                <li>
                  <UncontrolledDropdown>
                    <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                      <Icon name="setting"></Icon>
                    </DropdownToggle>
                    <DropdownMenu end className="dropdown-menu-xs">
                      <ul className="link-check">
                        <li>
                          <span>Show</span>
                        </li>
                        {[10, 20, 30, 50, 100].map((num) => (
                          <li key={num}>
                            <DropdownItem
                              className={`dropdown-item ${itemPerPage === num ? "active" : ""}`}
                              href="#dropdownitem"
                              onClick={() => setItemPerPage(num)}
                            >
                              {num}
                            </DropdownItem>
                          </li>
                        ))}
                      </ul>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
              </ul>
            </div>
            <div className={`card-search search-wrap ${onSearch && "active"}`}>
              <div className="search-content">
                <Button
                  color="link"
                  onClick={() => {
                    setSearchText("");
                    setonSearch(false);
                  }}
                  className="search-back btn-icon toggle-search"
                >
                  <Icon name="arrow-left"></Icon>
                </Button>
                <input
                  type="text"
                  className="border-transparent form-focus-none form-control"
                  placeholder="Search..."
                  value={onSearchText}
                  onChange={(e) => onFilterChange(e)}
                />
                <Button color="link" className="search-submit btn-icon">
                  <Icon name="search"></Icon>
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <DataTableBody bodyclass="nk-tb-tnx">
          <DataTableHead className="nk-tb-item">
            <DataTableRow>
              <span className="fw-bold">Appointment Number </span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">User</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Doctor</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Feedback</span>
            </DataTableRow>
            {/* <DataTableRow>
              <span className="fw-bold">Doctor ID</span>
            </DataTableRow> */}
            <DataTableRow>
              <span className="fw-bold">Rating</span>
            </DataTableRow>
            {/* <DataTableRow size={"md"}>
              <span className="fw-bold">Feedback</span>
            </DataTableRow> */}
            <DataTableRow>
              <span className="fw-bold">Date and Time</span>
            </DataTableRow>

            {/* <DataTableRow size={"md"}>
              <span className="fw-bold">Doctor</span>
            </DataTableRow> */}
            {/* <DataTableRow size={"md"}>
              <span className="fw-bold">User</span>
            </DataTableRow> */}
          </DataTableHead>

          {isLoading ? (
            <MyLoader />
          ) : (
            <>
              {data?.length > 0 ? (
                data.map((item, idx) => (
                  <DataTableItem key={item?.id || idx}>
                    <DataTableRow>
                      <span className="tb-sub">{item?.appointment_number || "-"}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="tb-lead">{item?.user || "-"}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="tb-sub">{item?.doctor || "-"}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="tb-sub">{item?.feedback || "-"}</span>
                    </DataTableRow>

                    {/* <DataTableRow>
                      <span className="tb-sub">
                        {item?.rating
                          ? "★".repeat(Math.floor(item.rating)) +
                          "☆".repeat(5 - Math.floor(item.rating))
                          : "-"}
                      </span>
                    </DataTableRow> */}
                    <DataTableRow>
                      <span className="tb-sub">
                        {item?.rating ? (
                          <>
                            <span style={{ color: "#FFD700" }}>
                              {"★".repeat(Math.floor(item.rating))}
                            </span>
                            <span style={{ color: "#ccc" }}>
                              {"★".repeat(5 - Math.floor(item.rating))}
                            </span>
                          </>
                        ) : (
                          "-"
                        )}
                      </span>
                    </DataTableRow>
                    {/* <DataTableRow size="md">
                      <span className="tb-sub">{item?.feedback || "-"}</span>
                    </DataTableRow> */}
                    <DataTableRow>
                      <span className="tb-sub">{formatDate(item?.date)}</span>
                    </DataTableRow>
                    {/* <DataTableRow>
                      <span className="tb-sub">{formatDate(item?.updatedAt)}</span>
                    </DataTableRow> */}
                    {/* <DataTableRow size="md">
                      <span className="tb-sub">{item?.doctor || "-"}</span>
                    </DataTableRow> */}
                    {/* <DataTableRow size="md">
                      <span className="tb-sub">{item?.user || "-"}</span>
                    </DataTableRow> */}

                  </DataTableItem>
                ))
              ) : (
                <DataTableItem>
                  <DataTableRow>
                    <span className="text-muted">No reviews found</span>
                  </DataTableRow>
                </DataTableItem>
              )}
            </>
          )}
        </DataTableBody>
          </div>

        {noPagination ? null : (
          <div className="card-inner">
            {data?.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={limit}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : null}
          </div>
        )}
      </DataTable>
    </>
  );
};

export default ReviewTable;
